/**
 * @generated SignedSource<<274eb04b2715bfe116b416f369572ce0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ContentKind = "ELearning" | "%future added value";
export type ContentSubmissionStatus = "active" | "failed" | "passed" | "%future added value";
export type RewardKind = "Certificate" | "Email" | "MakeFachberater" | "PacPoints" | "PharmaPoints" | "Points" | "%future added value";
export type RewardResultKind = "CertificateRewardAlreadyRewardedResult" | "CertificateRewardWasNotPossibleResult" | "CertificateRewardWasPossibleResult" | "EmailRewardAlreadyRewardedResult" | "EmailRewardWasNotPossibleResult" | "EmailRewardWasPossibleResult" | "FachberaterWasAwarded" | "MakeFachberaterRewardAlreadyRewardedResult" | "MakeFachberaterRewardWasNotPossibleResult" | "PacPointsRewardAlreadyRewardedResult" | "PacPointsRewardWasNotPossibleResult" | "PacPointsRewardWasPossibleResult" | "PharmaPointsRewardAlreadyRewardedResult" | "PharmaPointsRewardWasNotPossibleResult" | "PharmaPointsRewardWasPossibleResult" | "PointsRewardAlreadyRewardedResult" | "PointsRewardWasNotPossibleResult" | "PointsRewardWasPossibleResult" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type UserContentSubmissionDialog_QueryFragment$data = {
  readonly Admin: {
    readonly UsersContentSubmission: {
      readonly ContentSubmissions: {
        readonly __id: string;
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly definition: {
              readonly contentKind?: ContentKind;
              readonly rewardResults?: ReadonlyArray<{
                readonly kind: RewardResultKind;
                readonly rewardId?: string;
                readonly rewardKind: RewardKind;
              }>;
              readonly status: ContentSubmissionStatus;
            };
            readonly id: string;
            readonly lastUpdated: string | null | undefined;
            readonly learnOpportunity: {
              readonly root: {
                readonly structureDefinition: {
                  readonly extension?: {
                    readonly configConsequences?: {
                      readonly restartTriesCount: number | null | undefined;
                    };
                  };
                  readonly title: string;
                };
              } | null | undefined;
              readonly structureDefinition: {
                readonly title: string;
              };
            } | null | undefined;
            readonly startedAt: string;
          };
        } | null | undefined> | null | undefined;
        readonly pageInfo: {
          readonly endCursor: string | null | undefined;
          readonly hasNextPage: boolean;
          readonly hasPreviousPage: boolean;
          readonly startCursor: string | null | undefined;
        };
      };
    };
  };
  readonly " $fragmentType": "UserContentSubmissionDialog_QueryFragment";
};
export type UserContentSubmissionDialog_QueryFragment$key = {
  readonly " $data"?: UserContentSubmissionDialog_QueryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserContentSubmissionDialog_QueryFragment">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "Admin",
  "UsersContentSubmission",
  "ContentSubmissions"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rewardKind",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "contentNodeId"
    },
    {
      "defaultValue": 20,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": require('./UserContentSubmissionDialog_Refetch.graphql')
    }
  },
  "name": "UserContentSubmissionDialog_QueryFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AdminQueryType",
      "kind": "LinkedField",
      "name": "Admin",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UsersContentSubmissionAdminSchema",
          "kind": "LinkedField",
          "name": "UsersContentSubmission",
          "plural": false,
          "selections": [
            {
              "alias": "ContentSubmissions",
              "args": [
                {
                  "kind": "Variable",
                  "name": "contentId",
                  "variableName": "contentNodeId"
                },
                {
                  "kind": "Variable",
                  "name": "userId",
                  "variableName": "userId"
                }
              ],
              "concreteType": "ContentSubmissionsConnection",
              "kind": "LinkedField",
              "name": "__UserContentSubmissionDialog_ContentSubmissions_connection",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PageInfo",
                  "kind": "LinkedField",
                  "name": "pageInfo",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "endCursor",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasPreviousPage",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "hasNextPage",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "startCursor",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ContentSubmissionsEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ContentSubmission",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "id",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "startedAt",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "lastUpdated",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": null,
                          "kind": "LinkedField",
                          "name": "definition",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "status",
                              "storageKey": null
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": null,
                                  "kind": "LinkedField",
                                  "name": "rewardResults",
                                  "plural": true,
                                  "selections": [
                                    (v1/*: any*/),
                                    (v2/*: any*/)
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "type": "PassedELearningContentSubmissionDefinition",
                              "abstractKey": null
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "contentKind",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": null,
                                  "kind": "LinkedField",
                                  "name": "rewardResults",
                                  "plural": true,
                                  "selections": [
                                    (v1/*: any*/),
                                    {
                                      "alias": null,
                                      "args": null,
                                      "kind": "ScalarField",
                                      "name": "rewardId",
                                      "storageKey": null
                                    },
                                    (v2/*: any*/)
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "type": "FailedELearningContentSubmissionDefinition",
                              "abstractKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "LearnOpportunityV2",
                          "kind": "LinkedField",
                          "name": "learnOpportunity",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "LearnOpportunityV2",
                              "kind": "LinkedField",
                              "name": "root",
                              "plural": false,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": null,
                                  "kind": "LinkedField",
                                  "name": "structureDefinition",
                                  "plural": false,
                                  "selections": [
                                    (v3/*: any*/),
                                    {
                                      "kind": "InlineFragment",
                                      "selections": [
                                        {
                                          "alias": null,
                                          "args": null,
                                          "concreteType": null,
                                          "kind": "LinkedField",
                                          "name": "extension",
                                          "plural": false,
                                          "selections": [
                                            {
                                              "kind": "InlineFragment",
                                              "selections": [
                                                {
                                                  "alias": null,
                                                  "args": null,
                                                  "concreteType": "InfectopharmTreeConfigConsequences",
                                                  "kind": "LinkedField",
                                                  "name": "configConsequences",
                                                  "plural": false,
                                                  "selections": [
                                                    {
                                                      "alias": null,
                                                      "args": null,
                                                      "kind": "ScalarField",
                                                      "name": "restartTriesCount",
                                                      "storageKey": null
                                                    }
                                                  ],
                                                  "storageKey": null
                                                }
                                              ],
                                              "type": "LearnOpportunityRootExtensionImpl",
                                              "abstractKey": null
                                            }
                                          ],
                                          "storageKey": null
                                        }
                                      ],
                                      "type": "LearnOpportunityRootStructureDefinition",
                                      "abstractKey": null
                                    }
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": null,
                              "kind": "LinkedField",
                              "name": "structureDefinition",
                              "plural": false,
                              "selections": [
                                (v3/*: any*/)
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "__typename",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "cursor",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "kind": "ClientExtension",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__id",
                      "storageKey": null
                    }
                  ]
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "30156e1d3b18350d1628427f40998765";

export default node;
